import { Component, OnInit } from '@angular/core';
import { ReportService } from '../Services/report.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-day-report-list',
  templateUrl: './day-report-list.component.html',
  styleUrls: ['./day-report-list.component.css']
})
export class DayReportListComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  year;
  month;
  list: any[];
  days = [];

  users = [];

  years = [];
  minyear = 2019;
  constructor(
    private DBserivice: ReportService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.mkYeasList();
    this.InitList();
  }

  //一覧の初期化
  InitList() {
    this.list = [];
    this.InitDays();

    this.DBserivice.getDailyList(this.year, this.month).subscribe(
      list => {
        this.createReportList(list);
      });
  }
  mkYeasList() {
    var year = new Date().getFullYear();
    var length = (year - this.minyear) + 1;
    var list = Array.apply(null, new Array(length)).map(function (v, i) { return year - i });

    this.years = [];
    list.forEach(val => {
      let y = { value: val, text: val + '年' };
      this.years.push(y);
    });
  }
  //カレンダー初期化
  InitDays() {
    this.days = [];
    let last = new Date(this.year, this.month, 0).getDate();
    let m = ('00' + this.month).slice(-2);
    for (let day = 0; day < last; day++) {
      let temp = {
        date: this.year + '-' + m + '-' + ('0000' + (day + 1)).slice(-2),
        report: 'NONE',
      }
      this.days.push(temp);
    }
  }

  //リストの生成
  createReportList(list) {
    let userslist = [];
    this.authService.getUserList(0, 1, 0, 0).subscribe(userlist => {					//ユーザーリスト取得
      for (let user in userlist) {
        this.InitDays();
        let last_updated = null;						//最終更新日
        list.forEach(item => {
          if (userlist[user].user_code == item.user_code) {
            this.days.forEach(day => {
              if (day['date'] == item.yyyymmdd) {
                day['report'] = item.daily_report_submit;
                if (item.updated_at) {
                  last_updated = item.updated_at;
                }
              }
            });
          }
        });

        let userReport = {
          user_code: userlist[user].user_code,
          name: userlist[user].user_family_name + ' ' + userlist[user].user_name,
          report: this.days,
          last_updated: last_updated,
        }
        userslist.push(userReport);
      }
      this.list = userslist;
    });
  }
}
